import type { AccountError } from '@/graphql/saleor/api';
import { formMessages } from '@/messages/forms';

import { commonErrorCodeMessages, type FormattedError } from './common';

export const getAddressErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'REQUIRED':
      return formMessages.requiredField;
    case 'INVALID':
      return formMessages.invalidField;
    default:
      return error.message ?? commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
